/* eslint-disable import/prefer-default-export */
import { httpDelete, httpGet, httpPost } from '../httpCalls';
import store from '../../store';
import { reloadOriginOutputs } from '../../actions/originOutputsActions';


export const createOriginOutput = (data) => {
  const vodId = store.getState().vods[0].id;
  return httpPost('originOutputs', { ...data, vodId }).then(() => httpGet(`vod/${vodId}`).then((vod) => {
    const originOutputs = vod.originOutputs.map((x) => {
      const element = { ...x };
      element.parent = vod.id;

      return element;
    });
    store.dispatch(reloadOriginOutputs(originOutputs));
    return originOutputs;
  }));
};
export const removeOriginOutput = (data) => {
  return httpDelete(`originOutputs/${data.id}`);
};
